import styles from "./styles.module.scss";
import React, { useEffect } from "react";
import useCollapse from "react-collapsed";
import { Link } from "react-router-dom";

function Collapsible() {
    const { getCollapseProps, getToggleProps, isExpanded } = useCollapse({ duration: 1000 });
    return (
        <div className={styles.collapsible}>
            <div className={styles.header} {...getToggleProps()}>
                <p>{isExpanded ? '-' : '+'}</p>
                <text>E-commerce et Marketplaces : nos domaines d’intervention</text>
            </div>
            <div {...getCollapseProps()}>
                <div className={styles.content}>
                    Pour vendre des produits et des services ou pour faire votre entrée dans l’économie collaborative,
                    nos professionnels vous accompagnent dans la conception et le développement sur mesure de votre site e-commerce ou marketplace.<br />
                    Horizontale, offrant un large éventail de produits de diverses catégories, ou verticale, exploitant une niche spécifique,
                    votre marketplace sera au plus près de vos attentes.
                </div>
            </div>
        </div>
    );
}
function Collapsible2() {
    const { getCollapseProps, getToggleProps, isExpanded } = useCollapse({ duration: 1000 });
    return (
        <div className={styles.collapsible}>
            <div className={styles.header} {...getToggleProps()}>
                <p>{isExpanded ? '-' : '+'}</p>
                <text>E-commerce et Marketplaces : notre méthodologie</text>
            </div>
            <div {...getCollapseProps()}>
                <div className={styles.content}>
                    Le business model et la technologie propres à un site e-commerce et à une marketplace ne sont pas identiques.<br />
                    Mobilisant des expertises pointues spécifiques à chaque type de plateforme, notre démarche fait toujours œuvre du même esprit de rigueur et de créativité.<br /><br />

                    Notre méthodologie se compose des 5 étapes suivantes :<br /><br />

                    <p>Étude des caractéristiques et des besoins de la cible</p>
                    <p>Développement de l’application Mobile</p>
                    <p>Test en ligne des fonctionnalités de l’application Mobile</p>
                    <p> Mise en ligne et enregistrement de l’application</p>
                    <p> Maintenance et optimisation continue</p>
                </div>
            </div>
        </div>
    );
}

function Intro() {
    useEffect(() => {
        window.scrollTo(0, 1000)
    }, [])

    return (
        <>
            <section className={styles.container}>
                <div className={styles.title}>
                    <text>E-commerce et Marketplace</text>
                    <p>pour la réussite de vos projets</p>
                </div>
                <div className={styles.bigbox}>

                    <div className={styles.service}>
                        <div className={styles.bigText}>E-commerce</div>
                        <div className={styles.paragraph}>
                            L’émergence des « marketplaces de services » est le signe annonciateur d’une nouvelle donne dans le commerce en ligne.<br /><br />

                            La place de marché doit communiquer au client son offre, en le rassurant sur la qualité et le sérieux de celle-ci. Elle doit proposer différents avantages
                            : sécurisation des échanges, notation des marchands, suivi des commandes, outils de paiement simples et sécurisés.<br /><br />

                            OrgaExpert maîtrise les technologies propres à la création de marketplaces.<br /><br />

                            Basé sur des CMS open source comme WordPress et Prestashop, nos solutions vous permettent de lancer votre activité e-commerce, de transformer votre site e-commerce actuel
                            en marketplace ou de lancer une activité marketplace à moindre coût.
                        </div>
                    </div>


                    <div className={styles.expandable}>
                        <Collapsible />
                        <Collapsible2 />
                    </div>

                </div>
                <div className={styles.title}>
                    <div className={styles.text2}>Autre services</div>
                </div>
                <div className={styles.bigbox2}>
                    <Link to="/services/developpementMobile">
                        <div className={styles.service1}>
                            <div className={styles.bigText}>Développement Mobile</div>
                            <img src="/icons/smartphone.png" alt="web dev" />
                        </div>
                    </Link>
                    <Link to="/services/developpementWeb">
                        <div className={styles.service1}>
                            <div className={styles.bigText}>Développement Web</div>
                            <img src="/icons/desktop.png" alt="web dev" />
                        </div>
                    </Link>

                    <Link to="/services/transformation_digital">
                        <div className={styles.service1}>
                            <div className={styles.bigText}>CONSEIL ET STRATÉGIE</div>
                            <img src="/icons/assist.png" alt="web dev" />

                        </div>
                    </Link>
                    <Link to="/services/erp">
                        <div className={styles.service1}>
                            <div className={styles.bigText}>INTÉGRATION ERP</div>
                            <img src="/icons/integration.png" alt="web dev" />

                        </div>
                    </Link>
                    <Link to="/services/seo">
                        <div className={styles.service1}>
                            <div className={styles.bigText}>SEO ET OPTIMISATION</div>
                            <img src="/icons/seo.png" alt="web dev" />
                        </div>
                    </Link>
                </div>
            </section>
        </>
    )
}

export default Intro;